import { Button, Col, Row, Table, Modal, Switch, Popconfirm, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import "./style/PlanPricing.scss";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { AddPlanPricing } from "./AddPlanPricing";
import { API_ERR_MESSAGE, PLANS } from "../../../config/constant";
import { setHeaderName } from "../../../services/SetHeaderName";
import { listOfPlansApi, updatePlanApi } from "../../../config/Api";

export const PlanPricing = () => {
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isPlanActive, setIsPlanActive] = useState(false)
    const [dataSource, setDataSource] = useState()
    const [isEdit, setIsEdit] = useState(false)
    const [editPlanRecord, setEditPlanRecord] = useState()
    const [buttonName, setButtonName] = useState('ADD')
    const [loading, setLoading] = useState(false)

    // get the list of alll available plans 
    //==============================
    const getListOfPlans = () => {
        setLoading(true)
        listOfPlansApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                // if (err.response) {
                //     if (err.response.data.code === 401) {
                notification.error({
                    message: 'something went wrong',
                });
                //     }
                // }
            });
    }


    useEffect(() => {
        setHeaderName(PLANS)
        getListOfPlans()
    }, []);
    const handleOk = () => {
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    // handle the status if plan pricing record
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.plan_status = checked;

        updatePlanApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Plan Update successfully",
                    });
                    getListOfPlans()
                    setIsModalVisible(false)
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };
    const editPlanData = (data) => {
        setButtonName("UPDATE")
        setEditPlanRecord(data);
        setIsModalVisible(true)
    }
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Active Clients',
            dataIndex: 'active_clients',
            key: 'active_client',
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
        },
        {
            title: 'Plan Status',
            dataIndex: 'plan_status',
            key: 'plan_status',
            render: (text, data) => <>
                <Switch checked={text} value={isPlanActive} onChange={(e) => { setIsPlanActive(!isPlanActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.plan_status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => editPlanData(record)} className="me-2" />
                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="PlanPricing">
                <Row>
                    <Col xs={6} sm={6} md={12} lg={6} xl={2} xxl={2} >
                        <Button htmlType="submit" className="submit-button  border-0 rounded ms-2 mb-2" icon={<PlusOutlined style={{ fontSize: "1.2rem" }} />} onClick={() => { setButtonName("SAVE"); setIsModalVisible(true) }}>
                            Add
                        </Button>
                    </Col>
                    <Col xs={18} sm={18} md={12} lg={18} xl={22} xxl={22} className="text-end align-self-center pe-4">
                        <h6>Total Plans: 5 </h6>
                    </Col>
                </Row>
                <Spin spinning={loading} className="spinner-code">
                    <Row>
                        <Col span={24}>

                            <Table
                                columns={columns}
                                dataSource={dataSource}
                                rowKey="id"
                                // pagination={false}
                                scroll={{ x: "max-content" }}
                                className="w-100"
                            />
                        </Col>
                    </Row>
                </Spin>
            </div>

            <Modal
                open={isModalVisible}
                centered
                footer={null}
                width={800}
                className="addPlanPricing rounded"
                onOk={handleOk} onCancel={handleCancel}
            >
                <AddPlanPricing
                    getListOfPlans={getListOfPlans}
                    editPlanRecord={editPlanRecord}
                    setIsModalVisible={setIsModalVisible}
                    setButtonName={setButtonName}
                    buttonName={buttonName}
                />
            </Modal>
        </>
    )
}
